"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

var base = /*#__PURE__*/(0, _react.css)("max-width:", (0, _util.rem)(880), ";padding-left:", (0, _util.rem)(40), ";padding-right:", (0, _util.rem)(40), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
var md = /*#__PURE__*/(0, _react.css)(base, ";max-width:", (0, _util.rem)(920), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:md;"));
var lg = /*#__PURE__*/(0, _react.css)(base, ";max-width:", (0, _util.rem)(1180), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:lg;"));
var xl = /*#__PURE__*/(0, _react.css)(base, ";max-width:", (0, _util.rem)(1320), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:xl;"));
var styles = {
  base: base,
  md: md,
  lg: lg,
  xl: xl
};
exports.styles = styles;
//# sourceMappingURL=container.styles.js.map